export const pGradeOrder = ["P10", "P9", "P8", "P7", "P6", "P5"];
const STAFF_GRADE_GROUP_ORDER = ["P", "T"] as const;

export function normalizePGrade(value?: string): string | undefined {
  const cleaned = String(value ?? "").trim().toUpperCase().replace(/\s+/g, "");
  if (/^P(10|9|8|7|6|5)$/.test(cleaned)) return cleaned;
  if (/^T[0-6]$/.test(cleaned)) return cleaned;
  return undefined;
}

export function isTechnicalPGrade(value?: string): boolean {
  return /^T[0-6]$/.test(String(value ?? "").trim().toUpperCase().replace(/\s+/g, ""));
}

export function gradeRank(value?: string): number {
  const grade = normalizePGrade(value);
  const idx = grade ? pGradeOrder.indexOf(grade) : -1;
  return idx === -1 ? pGradeOrder.length : idx;
}

export function employeeNoSortKey(employeeNo: string): number {
  const digits = employeeNo.replace(/\D/g, "");
  if (digits.length < 2) return Number.MAX_SAFE_INTEGER;
  const prefix = Number(digits.slice(0, 2));
  const year = prefix >= 90 ? 1900 + prefix : 2000 + prefix;
  return Number(`${year}${digits.slice(2).padStart(8, "0")}`);
}

export function sortEmployeesByGradeAndSeniority<T extends { pGrade?: string; employeeNo: string }>(items: T[]): T[] {
  return [...items].sort(compareEmployeesByStaffGrade);
}

export function compareEmployeesByStaffGrade<T extends { pGrade?: string; employeeNo: string }>(a: T, b: T): number {
  const gradeA = staffGradeSortKey(a.pGrade);
  const gradeB = staffGradeSortKey(b.pGrade);
  return gradeA.group - gradeB.group
    || gradeB.level - gradeA.level
    || employeeNoSortKey(a.employeeNo) - employeeNoSortKey(b.employeeNo)
    || a.employeeNo.localeCompare(b.employeeNo);
}

function staffGradeSortKey(value?: string) {
  const match = String(value ?? "").trim().toUpperCase().match(/^([PT])\s*(\d+)/);
  const group = match ? STAFF_GRADE_GROUP_ORDER.indexOf(match[1] as (typeof STAFF_GRADE_GROUP_ORDER)[number]) : -1;
  return {
    group: group === -1 ? STAFF_GRADE_GROUP_ORDER.length : group,
    level: match ? Number(match[2]) : 0,
  };
}
